import { memo } from 'react';
import { Text, ClickableArea } from '@library';
import styles from './UserMenu.module.scss';

const MenuItem = memo(
    ({ onClick, text }: { onClick?(): void; text?: string }) => (
        <ClickableArea
            role="button"
            tabIndex={0}
            onPress={() => {
                onClick?.();
            }}
            className={styles.navButton}
            data-text={text}
        >
            <Text secondary regular lineHeightAsFontSize>
                <span className={styles.navButtonText}>{text}</span>
            </Text>
        </ClickableArea>
    )
);

export default MenuItem;
